import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  imageList: {
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
    },
  },
  actions: {
    display: "flex",
    alignItems: "center",
  },
  root: {
    width: "100%",
  },
  wrapper: {
    padding: theme.spacing(2)
  },
  title: {
    color: "#333",
    fontSize: 24,
  }


}));

export default useStyles;
